import React from 'react';
import HeaderProfile from '../Components/HeaderProfile'


const Documents = () => (
    <>
        <HeaderProfile></HeaderProfile>
        <div className="toolbar py-2" id="kt_toolbar">
            <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                <div className="flex-grow-1 flex-shrink-0 me-5">
                    <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                        <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">My Profile</h1>
                        <span className="h-20px border-gray-200 border-start mx-3"></span>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                            <li className="breadcrumb-item">
                                <a href="/Settings/Myprofile" className="text-muted text-hover-primary">Documents</a>
                            </li>

                        </ul>
                    </div>
                </div>
                <div class="d-flex align-items-center flex-wrap">


                    <div class="flex-shrink-0 me-2 d-none-mob">
                        <ul class="nav" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a href='/settings'>
                                    <img src='/assets/images/back.png' width={30} /> </a>
                            </li>


                        </ul>
                    </div>


                </div>

            </div>
        </div>

        <section className='wraper'>
            <div className='box_shadow mt-14'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h3 className='headings'>Documents Details</h3>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 org_documnets'>
                        <ul class="nav nav-pills" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" data-bs-toggle="pill" href="#Passport">Passport</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-bs-toggle="pill" href="#Visa">Visa</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-bs-toggle="pill" href="#Insurance">Insurance</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-bs-toggle="pill" href="#Others">Others</a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div id="Passport" class="p-1 tab-pane fade active show">
                                <div className='row'>
                                    <div class="col-md-12 mb-3">
                                        <table className='table table-bordered'>
                                            <thead>
                                                <tr>
                                                    <th>Passport Number</th>
                                                    <th>Issue Date</th>
                                                    <th>Expiry Date</th>
                                                    <th>Date of Birth</th>
                                                    <th>Issuing Country</th>
                                                    <th>Place of Birth Country</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>DLKY0909</td>
                                                    <td>01/02/2023</td>
                                                    <td>02/03/2025</td>
                                                    <td>02/03/2025</td>
                                                    <td>India</td>
                                                    <td>India</td>
                                                    <td><a href='' data-bs-toggle="modal" data-bs-target="#PassportModal"><i className='fa fa-plus'></i>Add New</a></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>


                            </div>
                            <div id="Visa" class="p-1 tab-pane fade">
                                <div className='row'>
                                    <div class="col-md-12 mb-3">
                                        <table className='table table-bordered'>
                                            <thead>
                                                <tr>
                                                    <th>Visa Number</th>
                                                    <th>Issue Date</th>
                                                    <th>Expiry Date</th>
                                                    <th>Country Name</th>
                                                    <th>Visa Type</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>95856985</td>
                                                    <td>01/02/2023</td>
                                                    <td>02/03/2025</td>
                                                    <td>India</td>
                                                    <td>Tourist</td>
                                                    <td className='text-danger'>Active </td>
                                                    <td><a href='' data-bs-toggle="modal" data-bs-target="#VisaModal"><i className='fa fa-plus'></i>Add New</a></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                            <div id="Insurance" class="p-1 tab-pane fade">
                                <div className='row'>
                                    <div class="col-md-12 mb-3">
                                        <table className='table table-bordered'>
                                            <thead>
                                                <tr>
                                                    <th>Policy Number</th>
                                                    <th>Start date</th>
                                                    <th>End Date</th>
                                                    <th>Issuer Name</th>
                                                    <th>Region</th>
                                                    <th>Nominee</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>5856985</td>
                                                    <td>01/02/2023</td>
                                                    <td>02/03/2025</td>
                                                    <td>XYZ</td>
                                                    <td>Delhi</td>
                                                    <td>ABC</td>
                                                    <td className='text-danger'>Active </td>
                                                    <td><a href='' data-bs-toggle="modal" data-bs-target="#InsuranceModal"><i className='fa fa-plus'></i>Add New</a></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                            <div id="Others" class="p-1 tab-pane fade">
                                <div className='row'>
                                    <div class="col-md-12 mb-3">
                                        <table className='table table-bordered'>
                                            <thead>
                                                <tr>
                                                    <th>Document Type</th>
                                                    <th>Document Number</th>
                                                    <th>Issue Date</th>
                                                    <th>Expiry Date</th>
                                                    <th>Date of Birth</th>
                                                    <th>Place</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>DL</td>
                                                    <td>95856985</td>
                                                    <td>01/02/2023</td>
                                                    <td>02/03/2025</td>
                                                    <td>India</td>
                                                    <td>Tourist</td>
                                                    <td className='text-danger'>Active </td>
                                                    <td><a href='' data-bs-toggle="modal" data-bs-target="#OthersModal"><i className='fa fa-plus'></i>Add New</a></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        {/* Popup Start */}

        <div class="modal fade" id="PassportModal">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Passport</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <div className='row'>
                            <div class="col-md-3 mb-3">
                                <label className='required'>Passport Number</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-3 mb-3">
                                <label className='required'>Upload Passport front</label>
                                <input class="form-control form-control-solid" type="file" name="" />
                            </div>
                            <div class="col-md-3 mb-3">
                                <label className='required'>Upload Passport Back</label>
                                <input class="form-control form-control-solid" type="file" name="" />
                            </div>
                            <div class="col-md-3 mb-3">
                                <label className='required'>Issue Date</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-3 mb-3">
                                <label className='required'>Expiry Date</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-3 mb-3">
                                <label>Issuing Country</label>
                                <select class="form-select form-select-solid">
                                    <option value="Success">India</option>
                                </select>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label className=''>Place of Issue</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-3 mb-3">
                                <label className='required'>Place of Birth Country</label>
                                <select class="form-select form-select-solid">
                                    <option value="Success">India</option>
                                </select>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label className=''>Place of Birth City & State</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-3 mb-3">
                                <label className='required'>Father's Name</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-3 mb-3">
                                <label className='required'>Mother's Name</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-3 mb-3">
                                <label>Martial Status</label>
                                <select class="form-select form-select-solid">
                                    <option value="Success">Married</option>
                                    <option value="Success">Single</option>
                                    <option value="Success">Un-Married</option>
                                </select>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label className=''>Spouse Name</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-3 mb-3">
                                <label>Type of Passport</label>
                                <select class="form-select form-select-solid">
                                    <option value="Success">Diplomatic Passport</option>
                                    <option value="Success">Emergency / Temporary Passport</option>
                                    <option value="Success">Official / Service Passport</option>
                                    <option value="Success">Ordinary / Regular / Tourist Passport</option>
                                    <option value="Success">Refugee / Stateless Passport</option>
                                </select>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label className=''>Address As per Passport</label>
                                <textarea className='form-controls form-control-solid' rows={3} placeholder='Address...'></textarea>
                            </div>
                            <div class="col-md-12 mb-3 text-end">
                                <button className='btn btn-primary m-2'>Update</button>
                            </div>
                        </div>





                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade" id="VisaModal">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Visa</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <div className='row'>
                            <div class="col-md-4 mb-3">
                                <label className='required'>Visa Number</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className='required'>Upload Visa Copy</label>
                                <input class="form-control form-control-solid" type="file" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Issue Date</label>
                                <input class="form-control form-control-solid" type="date" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Expiry Date</label>
                                <input class="form-control form-control-solid" type="date" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Country Name</label>
                                <select class="form-select form-select-solid">
                                    <option value="Success">India</option>
                                    <option value="Success">Pakistan</option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Visa Type</label>
                                <select class="form-select form-select-solid">
                                    <option value="Success">Tourist</option>
                                    <option value="Success">Business</option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Status</label>
                                <select class="form-select form-select-solid">
                                    <option value="Success">Active</option>
                                    <option value="Success">D-Active</option>
                                    <option value="Success">Disabled</option>
                                </select>
                            </div>
                            <div class="col-md-12 mb-3 text-end">
                                <button className='btn btn-primary m-2'>Update</button>
                            </div>
                        </div>





                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade" id="InsuranceModal">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Insurance</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <div className='row'>
                            <div class="col-md-4 mb-3">
                                <label className='required'>Policy Number</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className='required'>Upload Policy Copy</label>
                                <input class="form-control form-control-solid" type="file" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Start date</label>
                                <input class="form-control form-control-solid" type="date" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>End Date</label>
                                <input class="form-control form-control-solid" type="date" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Issuer Name</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Region</label>
                                <select class="form-select form-select-solid">
                                    <option value="Success">Delhi</option>
                                    <option value="Success">Mumbai</option>
                                    <option value="Success">London</option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Nominee</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Status</label>
                                <select class="form-select form-select-solid">
                                    <option value="Success">Active</option>
                                    <option value="Success">D-Active</option>
                                    <option value="Success">Disabled</option>
                                </select>
                            </div>
                            <div class="col-md-12 mb-3 text-end">
                                <button className='btn btn-primary m-2'>Update</button>
                            </div>
                        </div>





                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="OthersModal">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Others</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <div className='row'>
                            <div class="col-md-4 mb-3">
                                <label className=''>Document Type</label>
                                <select class="form-select form-select-solid">
                                    <option value="Success">Passport</option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className='required'>Document Number</label>
                                <input class="form-control form-control-solid" type="text" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className='required'>Upload Document Front</label>
                                <input class="form-control form-control-solid" type="file" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Upload Document Back</label>
                                <input class="form-control form-control-solid" type="file" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Issue Date</label>
                                <input class="form-control form-control-solid" type="date" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Expiry Date</label>
                                <input class="form-control form-control-solid" type="date" name="" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Date of Birth</label>
                                <input class="form-control form-control-solid" type="date" name="" />
                            </div>

                            <div class="col-md-4 mb-3">
                                <label className=''>Place</label>
                                <select class="form-select form-select-solid">
                                    <option value="Success">Delhi</option>
                                    <option value="Success">Mumbai</option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label className=''>Status</label>
                                <select class="form-select form-select-solid">
                                    <option value="Success">Active</option>
                                    <option value="Success">D-Active</option>
                                    <option value="Success">Disabled</option>
                                </select>
                            </div>
                            <div class="col-md-12 mb-3 text-end">
                                <button className='btn btn-primary m-2'>Update</button>
                            </div>
                        </div>





                    </div>
                </div>
            </div>
        </div>


    </>

);

export default Documents;
